import React, { useState } from 'react';
import Select from 'react-select';

const MultiSelectDropdown = ({ options, onChange }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleChange = (selected) => {
    setSelectedOptions(selected);
    onChange(selected); // Pass selected options back to parent component or handler
  };
 
  return (
    <div  style={{ height:"auto"}}>

   
    <Select
      classNamePrefix="Select"
      isMulti
      value={selectedOptions}
      options={options}
      onChange={handleChange}
      placeholder="Service Options"
      closeMenuOnSelect={false}

     
    /> </div>
  );
};

export default MultiSelectDropdown;
